import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"
import { InventConnectRouteBoundary } from "@/components/invent-connect-route"
import { Logo } from "@/components/logo"
import { validateInventOAuthRequest } from "@/lib/invent-oauth"
import { getInventOAuthConfig } from "@/server/invent-oauth"

export const Route = createFileRoute("/_public/integrations/invent/connect")({
  loader: async ({ location }) => {
    const config = await getInventOAuthConfig()
    const validation = config
      ? validateInventOAuthRequest(location.searchStr, config)
      : { ok: false as const, error: "configuration_unavailable" as const }
    return { config, validation }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { config, validation } = Route.useLoaderData()
  const request = validation.ok ? validation.request : null

  return (
    <main className="flex min-h-svh items-center justify-center bg-background px-6 py-10">
      <div className="w-full max-w-sm space-y-10">
        <Logo className="flex justify-center px-0 md:px-0" width="w-full max-w-72" />
        {config && (validation.ok || validation.error !== "configuration_unavailable") ? (
          <InventConnectRouteBoundary
            config={config}
            validatedRequest={request}
            navigate={(target) => window.location.assign(target)}
            onExit={() => window.close()}
          />
        ) : (
          <p className="text-center text-sm text-muted-foreground">
            {t("invent.errors.unavailable")}
          </p>
        )}
      </div>
    </main>
  )
}
